import React, {ReactElement} from "react";

import fetchConditionalForm from "../form-conditions/field-conditions/form-registry";
import {SimpleFormProps} from "/src/types";
import SimpleForm from "../simple-form/SimpleForm";

const SimpleFormWrapper = (props: SimpleFormProps): ReactElement => {
  const {name} = props;
  const formName = name || "";
  const conditionalForm = fetchConditionalForm(formName, props);

  return conditionalForm || <SimpleForm {...props} />;
};

export default SimpleFormWrapper;
